import { render } from "./Dialogflow.vue?vue&type=template&id=101f01ec"
import script from "./Dialogflow.vue?vue&type=script&lang=js"
export * from "./Dialogflow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__